export const MEDIA_ENTITY = 'media';
